import PayoutsWidget from './PayoutsWidget';

export default PayoutsWidget;
